(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.closest('form');
    const section = root.closest('[data-product-section]');
    if (!form || !section) return;
    const product = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const inputs = [...root.querySelectorAll('input[type="radio"]')];
    let selectedVariant = null;
    function select() {
      const selected = inputs.find(input => input.checked);
      selectedVariant = product.variants.find(v => v.title === selected.dataset.title && v.price === Number(selected.dataset.price));
      section.querySelectorAll('[data-product-price],[data-sticky-price]').forEach(node => {
        node.textContent = new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'}).format(Number(selected.dataset.price) / 100);
      });
      const tierPrice = Number(selected.dataset.price);
      const giftValues = { essential: 0, fan: 3999, fire: 10997 };
      const compareAt = Math.round((tierPrice + 5000 + (giftValues[selected.value] || 0)) / 100) * 100;
      section.querySelectorAll('[data-product-compare-price]').forEach(node => {
        node.hidden = compareAt <= tierPrice;
        node.textContent = new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'}).format(compareAt / 100);
      });
      section.querySelectorAll('[data-product-savings-badge]').forEach(node => {
        node.hidden = compareAt <= tierPrice;
        node.textContent = 'Économisez ' + Math.round((compareAt - tierPrice) * 100 / compareAt) + '%';
      });
      section.querySelectorAll('[data-add-to-cart],[data-sticky-submit]').forEach(button => {button.disabled = !selectedVariant?.available;});
      root.querySelector('[data-discelo-preview]').hidden = Boolean(selectedVariant?.available);
      const contents = {
        essential: {'Mini-vinyles': '3', 'Cadeaux inclus': 'Aucun'},
        fan: {'Mini-vinyles': '9', 'Cadeaux inclus': 'Collier Croix & Guitare Johnny Hallyday', 'Livraison': 'Offerte'},
        fire: {'Mini-vinyles': '9', 'Cadeaux inclus': 'Collier Croix & Guitare Johnny Hallyday + Collier Portrait Johnny Hallyday + Bracelet Croix & Guitare Johnny Hallyday', 'Livraison': 'Offerte', 'Protection colis': 'Offerte'}
      };
      form.querySelectorAll('[data-discelo-property]').forEach(node => node.remove());
      for (const [name, value] of Object.entries({...contents[selected.value], _discelo_tier: selected.value})) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'properties[' + name + ']'; input.value = value;
        input.setAttribute('data-discelo-property', '');
        form.appendChild(input);
      }
      if (selectedVariant) {
        section.querySelectorAll('[data-variant-id-input]').forEach(input => {input.value = selectedVariant.id;});
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariant.id);
        window.history.replaceState({}, '', url);
      }
    }
    inputs.forEach(input => input.addEventListener('change', select));
    form.addEventListener('submit', event => {
      if (!selectedVariant?.available) {event.preventDefault();event.stopImmediatePropagation();}
    }, true);
    select();
  }
  const start = () => document.querySelectorAll('[data-discelo-tiers]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-discelo-tiers]').forEach(init));
})();
